import React from 'react'
import Container from '../../../../components/Container'
import { FormAgency } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const AgencyCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormAgency typeForm="create" />
  </Container>
)

export default AgencyCreate
